import React, { useState } from "react";
import { motion } from "framer-motion";
import { useCart } from "./CartContext";

const RepairGasRefill = () => {
  const { addToCart } = useCart();
  const [openDetail, setOpenDetail] = useState("");
  const [openFaq, setOpenFaq] = useState(null);

  const toggleDetails = (service) => {
    setOpenDetail(openDetail === service ? "" : service);
  };

  const services = [
    {
  title: "AC Not Cooling Properly",
  price: 499,
  image: "/images/repair.jpg",
  time: "30 mins",
  issues: [
    "Cleaning of condensate line",
    "Blower unit cleaning",
    "Air filter cleaning",
    "Drain pipe check & clean",
    "Drain tray cleaning",
    "Testing and fixing cooling issue",
  ],
},
{
  title: "AC Power Issue Repair",
  price: 499,
  image: "/images/repair.jpg",
  time: "60 mins",
  issues: [
    "Checking all electrical points",
    "Fixing power supply problems",
    "Replacing damaged wires if needed",
  ],
},
{
  title: "AC Noise or Smell Problem",
  price: 499,
  image: "/images/repair.jpg",
  time: "60 mins",
  issues: [
    "Fan blade cleaning",
    "Checking motor noise & bearings",
    "Filter replacement if required",
  ],
},
{
  title: "AC Water Leakage Fix",
  price: 619,
  image: "/images/repair.jpg",
  time: "60 mins",
  issues: [
    "Drain pan inspection",
    "Cleaning blocked drain pipe",
    "Fixing any leakage points",
  ],
},
{
  title: "AC Not Working",
  price: 499,
  image: "/images/repair.jpg",
  time: "60 mins",
  issues: [
    "Clearing debris from outdoor",
    "Checking the filter",
    "Check the condensate drain line",
  ],
},
{
  title: "Gas Refill (Split/Window AC)",
  price: 2199,
  image: "/images/repair.jpg",
  time: "2 hrs",
  issues: [
    "Solving cooling issues",
    "Checking for gas leaks",
    "Refilling gas properly",
  ],
},
];

  const faqs = [
    {
      question: "What if my AC doesn’t actually need a gas refill after inspection?",
    answer:
      "In that case, only the inspection charge of ₹299 will be applicable.",
  },
  {
    question: "Is the booking fee inclusive of spare parts?",
    answer:
      "No, the amount paid during booking is a visit fee, which will be adjusted in your final bill if you go ahead with the repair.",
  },
  {
    question: "What if the same issue comes back again?",
    answer:
      "We provide warranty on our repairs. If the problem returns, we’ll fix it at no extra cost.",
  },
  {
    question: "What if I’m quoted more than expected?",
    answer:
      "Technicians are not allowed to exceed fixed prices. If it happens, please contact our support team.",
  },
  {
    question: "How do I check if the shared quote is correct?",
    answer:
      "All pricing is reviewed by our backend team. You can also consult with an expert via the app.",
  },
  {
    question: "Are parts replaced during service under warranty?",
    answer:
      "Yes, parts provided by us come with a warranty. Items arranged by you are not covered.",
  },
  {
    question: "What if my appliance needs workshop-level repair?",
    answer:
      "We’ll shift it to our service center and keep you informed about the repair using original parts.",
  },
  {
    question: "If a problem is found during servicing, what happens?",
    answer:
      "The technician will explain the issue and share an estimate as per the fixed rate card. It’s your call how to proceed.",
  },
  {
    question: "Will the technician carry all required tools?",
    answer:
      "Yes, except ladders. If your AC is placed at height, please ensure one is available.",
  },
  {
    question: "How do I know genuine parts are being used?",
    answer:
      "We only use components that pass our quality checks and standards.",
  },
  {
    question: "What if something breaks down after the job is done?",
    answer:
      "Your repair and parts are covered under warranty. You can request a free follow-up visit within the warranty period.",
  },
];

  return (
  <div style={{ padding: 10, maxWidth: 800, margin: "auto" }}>
    <h1 className="text-3xl font-bold mb-6">AC Repair & Gas Refill Services</h1>

    {services.map((service, index) => (
      <div
        key={index}
        className="service-card"
        style={{
          border: "1px solid #ccc",
          borderRadius: 10,
          padding: 20,
          marginBottom: 20,
          backgroundColor: "#f9f9f9",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 10,
          flexWrap: "wrap", // 👈 mobile overflow fix
        }}
      >
        {/* Left side: content */}
        <div style={{ flex: 1, minWidth: "150px" }}>
          <h2 style={{ fontSize: 18, fontWeight: "bold" }}>{service.title}</h2>
          <p style={{ color: "#555" }}>₹{service.price} - {service.time}</p>

          <div style={{ marginTop: 10, display: "flex", gap: 10 }}>
            <button
              onClick={() => toggleDetails(service.title)}
              style={{
                padding: "6px 12px",
                backgroundColor: "#007bff",
                color: "white",
                border: "none",
                borderRadius: 5,
                cursor: "pointer",
              }}
            >
              View Details
            </button>
            <button
              onClick={() => addToCart({ ...service, name: service.title })}
              style={{
                padding: "6px 12px",
                backgroundColor: "#28a745",
                color: "white",
                border: "none",
                borderRadius: 5,
                cursor: "pointer",
              }}
            >
              Add
            </button>
          </div>
        </div>

        {/* Right side: image */}
        <img
          src={service.image}
          alt={service.title}
          className="service-image"
          style={{
            width: 120,
            height: 120,
            objectFit: "cover",
            borderRadius: 10,
            flexShrink: 0
          }}
        />

        {/* Expandable Details */}
        {openDetail === service.title && (
          <motion.div
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.3 }}
            style={{
              marginTop: 15,
              backgroundColor: "#eef2f7",
              borderRadius: 8,
              padding: 15,
              flexBasis: "100%", // 👈 details neeche full width lega
            }}
          >
            <h3 style={{ fontWeight: "bold", marginBottom: 5 }}>{service.title}</h3>
            <p style={{ marginBottom: 10 }}>₹{service.price} - {service.time}</p>
            <h4 style={{ fontWeight: "bold" }}>Common Issues Covered</h4>
            <ul style={{ paddingLeft: 20 }}>
              {service.issues.map((issue, i) => (
                <li key={i} style={{ fontSize: 14 }}>{issue}</li>
              ))}
            </ul>
            <h4 style={{ fontWeight: "bold", marginTop: 10 }}>Top technicians</h4>
            <ul style={{ paddingLeft: 20, fontSize: 14 }}>
              <li>Background verified</li>
              <li>Trained across all major brands</li>
            </ul>
            <p style={{ fontSize: 13, marginTop: 5 }}>We Service All Brands</p>
          </motion.div>
          )}
        </div>
      ))}

      <div style={{ marginTop: 40 }}>
        <h2 className="text-2xl font-bold mb-4">Frequently Asked Questions</h2>
        {faqs.map((faq, index) => (
          <div
            key={index}
            style={{
              border: "1px solid #ccc",
              borderRadius: 10,
              padding: 20,
              marginBottom: 20,
              backgroundColor: "#f9f9f9",
            }}
          >
            <button
              onClick={() => setOpenFaq(openFaq === index ? null : index)}
              style={{
                width: "100%",
                textAlign: "left",
                background: "none",
                border: "none",
                fontWeight: "bold",
                color: "#007bff",
                cursor: "pointer",
                fontSize: 16
              }}
            >
              {faq.question}
            </button>
            {openFaq === index && (
              <p style={{ marginTop: 15, textAlign: "left", fontSize: 16, color: "Black" }}>{faq.answer}</p>
            )}
          </div>
        ))}
        <div style={{ height: "400px" }}></div>
      </div>
    </div>
  );
};

export default RepairGasRefill;
